import React from 'react'
import './style.scss'
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

const LeftSidebar = ({ rawMarkdownBody, sidebarMenu }) => {
  const sidebar = rawMarkdownBody.replace(/.md/gi, '.html')

  return (
    <div className={`sidebar ${sidebarMenu}`}>
      <div className='sidebar__content scrollbar'>
        <ReactMarkdown skipHtml remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{sidebar}</ReactMarkdown>
      </div>
    </div>
  )
}
export default LeftSidebar
